import type { APIError } from './api'

// The API reports field errors under `validationErrors.<record>.attributes`, keyed by attribute name.
// Some endpoints name the record after the model (`contact`), others use the generic `record`.
export const getValidationErrorAttributes = (
  error: APIError | undefined,
  recordKey: string,
): Record<string, string> => {
  const attributes: unknown =
    error?.validationErrors?.[recordKey]?.attributes ?? error?.validationErrors?.record?.attributes

  if (!attributes || typeof attributes !== 'object') {
    return {}
  }

  return Object.fromEntries(
    Object.entries(attributes).filter((entry): entry is [string, string] => typeof entry[1] === 'string'),
  )
}
